import React from "react";
import { SectionHeader } from "../../../components/Shared";
import { scoreColor, MiniBar } from "./facilityHelpers";

const WaterPanel = ({ d }) => (
  <div>
    {/* Water Tanks */}
    <SectionHeader title="Water Tank Monitoring" />
    <div className="fm-tanks-grid">
      {d.tanks.map(t => (
        <div key={t.id} className={`fm-tank-card ${t.status === "Critical" ? "fm-tank-critical" : t.status === "Low" ? "fm-tank-low" : ""}`}>
          {t.leakDetected && <div className="fm-leak-alert">⚠ Leakage Detected</div>}
          <div className="fm-tank-header">
            <span className="fm-tank-name">{t.name}</span>
            <span className={`fm-badge fm-badge-${t.status.toLowerCase()}`}>{t.status}</span>
          </div>
          <div className="fm-tank-visual">
            <div className="fm-tank-body">
              <div className="fm-tank-fill" style={{
                height: `${t.level}%`,
                background: t.level > 70 ? "linear-gradient(180deg,#34d399,#10b981)" : t.level > 30 ? "linear-gradient(180deg,#fcd34d,#f59e0b)" : "linear-gradient(180deg,#f87171,#ef4444)"
              }} />
            </div>
            <div className="fm-tank-pct">{t.level}%</div>
          </div>
          <div className="fm-tank-cap">{Math.floor(t.level / 100 * t.capacity).toLocaleString()} / {t.capacity.toLocaleString()} {t.unit}</div>
          <div className="fm-tank-footer">
            <span className={`fm-pump-dot ${t.pumpRunning ? "pump-on" : "pump-off"}`} />
            <span>{t.pumpRunning ? `Pump Running • ${t.flowRate} L/min` : "Pump Off"}</span>
          </div>
        </div>
      ))}
    </div>

    {/* Pump Status */}
    <SectionHeader title="Pump Status" />
    <div className="fm-pumps-grid">
      {d.pumps.map(p => (
        <div key={p.id} className={`fm-pump-card ${p.status === "Fault" ? "fm-pump-fault" : ""}`}>
          <div className="fm-pump-header">
            <span className="fm-pump-name">{p.name}</span>
            <span className="fm-pump-power">{p.power}</span>
          </div>
          <div className="fm-pump-status-row">
            <span className={`fm-pump-badge pump-${p.status.toLowerCase()}`}>{p.status}</span>
            <span className="fm-pump-health-lbl">Health: <strong style={{ color: scoreColor(p.health) }}>{p.health}%</strong></span>
          </div>
          <MiniBar value={p.health} max={100} color={scoreColor(p.health)} height={5} />
          <div className="fm-pump-meta">
            <span>Current: {p.current} A</span>
            <span>Runtime: {p.runtime}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default WaterPanel;
